import * as React from "react";
import { infoIcon } from "./InfoIconTooltip.module.scss";

export const InfoIcon = () => {
  return (
    <svg width={14} height={14} className={infoIcon}>
      <use xlinkHref="/svg/info-icon.svg#info-icon" />
    </svg>
  );
};
